import { defineComponent as _defineComponent } from 'vue'
import { useStore, ref, onBeforeMount } from '@nuxtjs/composition-api';
import { State } from '@/store';
import { Resource } from '@/types/resource';
import ResourcesListHorizontal from '@/components/resource/ResourcesListHorizontal.vue';

interface Props {
  title?: string;
  subheading?: string;
  align?: string;
  link?: string;
  parentResource?: Resource;
  params?: Record<string, any>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesListHorizontalCsr',
  props: {
    title: null,
    subheading: null,
    align: null,
    link: null,
    parentResource: null,
    params: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  subheading?: string;
  align?: string;
  link?: string;
  parentResource?: Resource;
  params?: Record<string, any>;
};

const $store = useStore<State>();



// load resources
const resources = ref<Resource[]>([]);
const loading = ref(true);
const loadResources = async () => {
  loading.value = true;
  try {
    const response = await $store.dispatch('loadResources', props.params);
    resources.value = response.list;
  } catch (err: Error | any) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

onBeforeMount(() => loadResources());

return { __sfc: true,$store, props, resources, loading, loadResources, ResourcesListHorizontal }
}

})